import { delay, put, takeLatest, race, take, select } from 'redux-saga/effects';
import { setTokenRefresh } from '../reducers/UserSlice';

function* handleRefreshTokenTimer() {
    // 3_000_000
    const { timeout, stop } = yield race({
        timeout: delay(3_000_000),
        stop: take('STOP_REFRESH_TIMER')
    });

    if (timeout) {
        
        yield put(setTokenRefresh(true));
    } 
}

export function* watchRefreshToken() {
    yield takeLatest('START_REFRESH_TIMER', handleRefreshTokenTimer);
}